module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Email Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.name),
      expression: "email.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name"
    },
    domProps: {
      "value": _vm._s(_vm.email.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "editor"
    }
  }, [_vm._v("Content")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "editor",
      "name": "editordata"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.email.content)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dbfe635!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/Editor.vue
// module id = 366
// module chunks = 0